module.exports = {"500109001":"天生街道","500109002":"朝阳街道","500109003":"北温泉街道","500109004":"东阳街道","500109005":"龙凤桥街道","500109101":"歇马镇","500109102":"澄江镇","500109103":"蔡家岗镇","500109104":"童家溪镇","500109105":"天府镇","500109108":"施家梁镇","500109109":"水土镇","500109110":"静观镇","500109111":"柳荫镇","500109112":"复兴镇","500109113":"三圣镇","500109116":"金刀峡镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500109.json
// module id = 2043
// module chunks = 0